<div *ngIf="message" [style.background-color]="color ? color : '#FFF3DC'" class="warning-no-return">
  <cx-icon class="regular-icon grey not-active" [type]="iconTypes.INFO"></cx-icon>
  <span [innerHTML]="message | safe"></span>
</div>